"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var chess_fen_1 = require("chess-fen");
var Board_1 = require("./utils/Board");
var renderers_1 = require("./utils/renderers");
var styles_1 = require("./styles");
var BoardRenderer_1 = __importDefault(require("./utils/BoardRenderer"));
var react_resize_aware_1 = __importDefault(require("react-resize-aware"));
exports.ChessBoard = function (_a) {
    var _b = _a.fen, fen = _b === void 0 ? chess_fen_1.Fen.startingPosition : _b, onMove = _a.onMove, _c = _a.rotated, rotated = _c === void 0 ? false : _c, _d = _a.pieceTheme, pieceTheme = _d === void 0 ? {} : _d, _e = _a.boardTheme, boardTheme = _e === void 0 ? {} : _e, props = __rest(_a, ["fen", "onMove", "rotated", "pieceTheme", "boardTheme"]);
    var _f = react_resize_aware_1.default(), resizeListener = _f[0], size = _f[1];
    var board = new Board_1.Board({ fen: fen, size: size.width, pieceTheme: pieceTheme, boardTheme: boardTheme, rotated: rotated });
    var _g = renderers_1.mergeBoardRenderers(props), renderPiece = _g.renderPiece, renderSquare = _g.renderSquare, renderPreviewPiece = _g.renderPreviewPiece, renderCoordinate = _g.renderCoordinate, renderBoard = _g.renderBoard, renderDroppableSquare = _g.renderDroppableSquare, renderDraggablePiece = _g.renderDraggablePiece;
    var boardProps = __assign(__assign({ board: board,
        onMove: onMove,
        resizeListener: resizeListener }, props), { renderDroppableSquare: renderDroppableSquare,
        renderDraggablePiece: renderDraggablePiece,
        renderPiece: renderPiece,
        renderSquare: renderSquare,
        renderPreviewPiece: renderPreviewPiece,
        renderCoordinate: renderCoordinate,
        renderBoard: renderBoard });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.ChessBoardStyles, null),
        react_1.default.createElement(BoardRenderer_1.default, __assign({}, boardProps))));
};
exports.default = exports.ChessBoard;
